
export enum EnumTpAceite {
    NaoAceito,
    Aceito
}